import { ReactNode } from 'react';
import { useAnalytics } from '@/hooks/use-analytics';

interface AnalyticsWrapperProps {
  children: ReactNode;
}

/**
 * Component that wraps the application to enable analytics tracking
 * This component ensures all page views are tracked automatically
 */
export const AnalyticsWrapper = ({ children }: AnalyticsWrapperProps) => {
  // Initialize analytics - this will track page views automatically
  useAnalytics();
  
  return <>{children}</>;
};
